import {Repository} from "@api/repositories/Repository";
import {AxiosInstance} from "axios";
import {WebinarInfo} from "../models/WebinarInfo";
import {WebinarInfoInterface} from "../models/interfaces/WebinatInfoInterface";

export class SessionRepository implements Repository {
    client: AxiosInstance;

    constructor(client: AxiosInstance) {
        this.client = client;
    }

    webinar(schema: string, sessionIds: string[]) {
        return this.client.post<{[key: string]: WebinarInfo}>(`/sessions/${schema}/webinar/query`, sessionIds)
            .then(({data }) => {
                for (const objectId in data) {
                    if (Object.prototype.hasOwnProperty.call(data, objectId)) {
                        data[objectId] = new WebinarInfo((data[objectId] as WebinarInfoInterface));
                    }
                }
                return data;
            })
    }
}